import { useEffect, useState } from 'react';

import { listSubscribers, ListSubscribersResponse } from '../api/subscribers';

export default function AdminSubscribersPage() {
  const [data, setData] = useState<ListSubscribersResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState('active');

  const load = (status: string) => {
    setLoading(true);
    setError(null);
    listSubscribers(status)
      .then(setData)
      .catch(() => setError('Failed to load subscribers.'))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load(statusFilter);
  }, [statusFilter]);

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '32px 16px' }}>
      <h2>Subscribers</h2>

      {data && (
        <div style={{ display: 'flex', gap: 24, marginBottom: 24 }}>
          {(['active', 'pending', 'unsubscribed'] as const).map((s) => (
            <div key={s} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 28, fontWeight: 700 }}>{data.counts[s]}</div>
              <div
                style={{ fontSize: 13, color: 'var(--text-muted)', textTransform: 'capitalize' }}
              >
                {s}
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginBottom: 16, display: 'flex', gap: 8 }}>
        {['active', 'pending', 'unsubscribed'].map((s) => (
          <button
            key={s}
            style={{
              padding: '6px 14px',
              borderRadius: 6,
              border: '1px solid var(--border-strong)',
              background: statusFilter === s ? 'var(--accent-solid)' : 'var(--bg-surface)',
              color: statusFilter === s ? '#fff' : 'var(--text-primary)',
              cursor: 'pointer',
              fontSize: 13,
              textTransform: 'capitalize',
            }}
            onClick={() => setStatusFilter(s)}
          >
            {s}
          </button>
        ))}
      </div>

      {loading && <p style={{ color: 'var(--text-muted)' }}>Loading…</p>}
      {error && <p style={{ color: 'var(--danger-text)' }}>{error}</p>}

      {data && !loading && (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ borderBottom: '2px solid var(--border-subtle)', textAlign: 'left' }}>
              <th style={{ padding: '8px 4px' }}>Email hash</th>
              <th style={{ padding: '8px 4px' }}>Status</th>
              <th style={{ padding: '8px 4px' }}>Subscribed at</th>
              <th style={{ padding: '8px 4px' }}>Unsubscribed at</th>
            </tr>
          </thead>
          <tbody>
            {data.items.length === 0 && (
              <tr>
                <td colSpan={4} style={{ padding: '16px 4px', color: 'var(--text-muted)' }}>
                  No subscribers with status &ldquo;{statusFilter}&rdquo;.
                </td>
              </tr>
            )}
            {data.items.map((sub) => (
              <tr key={sub.emailHash} style={{ borderBottom: '1px solid var(--border-subtle)' }}>
                <td style={{ padding: '8px 4px', fontFamily: 'monospace', fontSize: 11 }}>
                  {sub.emailHash.slice(0, 16)}…
                </td>
                <td style={{ padding: '8px 4px', textTransform: 'capitalize' }}>{sub.status}</td>
                <td style={{ padding: '8px 4px' }}>
                  {new Date(sub.subscribedAt).toLocaleDateString()}
                </td>
                <td style={{ padding: '8px 4px' }}>
                  {sub.unsubscribedAt ? new Date(sub.unsubscribedAt).toLocaleDateString() : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
